/**
 * [INPUT]: 依赖 vite-plugin-pwa 的 React 注册 hook 与 Button
 * [OUTPUT]: 对外提供 PwaUpdate 更新提示和离线就绪反馈
 * [POS]: app 的 service worker 生命周期界面，刷新必须由用户明确触发
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { RefreshCw, X } from 'lucide-react'
import { useRegisterSW } from 'virtual:pwa-register/react'

import { Button } from '@/components/ui/button'

export function PwaUpdate() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW()
  if (!needRefresh && !offlineReady) return null
  return (
    <aside className="update-toast" aria-live="polite">
      <p>{needRefresh ? 'Morrow 已有新版本。' : '应用外壳已可离线打开。'}</p>
      {needRefresh && (
        <Button variant="primary" size="compact" onClick={() => updateServiceWorker(true)}>
          <RefreshCw size={15} />
          更新
        </Button>
      )}
      <Button
        size="icon"
        variant="ghost"
        aria-label="关闭提示"
        onClick={() => {
          setNeedRefresh(false)
          setOfflineReady(false)
        }}
      >
        <X size={16} />
      </Button>
    </aside>
  )
}
